import React from 'react'
import PropTypes from 'prop-types'
import SitePicker from 'components/SitePicker'
import { ErrorBoundary, Loading } from 'secondstep-components'
import {
  VARIANT_K12_DWB,
  VARIANT_K8_CORE,
} from 'components/SiteUserTrainingGrid/constants'
import { domains } from 'config/env'
import {
  REDIRECT_TO_DASHBOARD,
  TRAINING_DESCRIPTION,
  TRAINING_DESCRIPTION_DWB,
  TITLE,
} from './constants'

import {
  Description,
  TextLinkContainer,
  StyledTextLink,
  StyledTextLinkDashboard,
  Title,
  TitleRow,
  SitePickerContainer,
  UserCount,
  TableContainer,
  LoadingWrapper,
} from './component.styles'
import ProgramVariantSelect from './ProgramVariantSelect'
import SiteUserTrainingGrid from 'components/SiteUserTrainingGrid'

const TrainingReport = ({
  className,
  isLoading,
  site,
  sites,
  siteUsers,
  onSiteChange,
  onReportVariantChange,
  pendingUsersCount,
  redirectToUserManagement,
  reportVariant,
  showProgramSelect,
}) => {
  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loading dataTestId="loading-logo" />
      </LoadingWrapper>
    )
  }

  const description =
    reportVariant === VARIANT_K12_DWB
      ? TRAINING_DESCRIPTION_DWB
      : TRAINING_DESCRIPTION

  return (
    <ErrorBoundary>
      <TextLinkContainer>
        <StyledTextLinkDashboard
          dataTestId="textlink-back-to-dashboard"
          href={`${domains.LEARN_APP_DOMAIN}`}
        >
          {REDIRECT_TO_DASHBOARD}
        </StyledTextLinkDashboard>
      </TextLinkContainer>
      <SitePickerContainer>
        <SitePicker
          onSiteChange={onSiteChange}
          selectedSite={site}
          sites={sites}
        />
      </SitePickerContainer>
      <TitleRow>
        <Title>{TITLE}</Title>
        {showProgramSelect && (
          <ProgramVariantSelect
            aria-label="Training program"
            dataTestId="training-report-program-select"
            onChange={onReportVariantChange}
            value={reportVariant}
          />
        )}
      </TitleRow>
      <Description>{description}</Description>
      {pendingUsersCount > 0 && (
        <UserCount>
          {pendingUsersCount} Pending Users -{' '}
          <StyledTextLink onClick={redirectToUserManagement}>
            User Management
          </StyledTextLink>
        </UserCount>
      )}
      <TableContainer>
        {siteUsers && (
          <SiteUserTrainingGrid
            className={className}
            users={siteUsers}
            variant={reportVariant}
          />
        )}
      </TableContainer>
    </ErrorBoundary>
  )
}

TrainingReport.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  onReportVariantChange: PropTypes.func.isRequired,
  onSiteChange: PropTypes.func,
  pendingUsersCount: PropTypes.number,
  redirectToUserManagement: PropTypes.func,
  reportVariant: PropTypes.oneOf([VARIANT_K8_CORE, VARIANT_K12_DWB]).isRequired,
  showProgramSelect: PropTypes.bool,
  site: PropTypes.object,
  siteId: PropTypes.number,
  siteUsers: PropTypes.array,
  sites: PropTypes.array,
}

TrainingReport.defaultProps = {
  isLoading: false,
  data: [],
  error: null,
  showProgramSelect: false,
}

export default TrainingReport
